// extracted by mini-css-extract-plugin
module.exports = {"canvas":"canvas-module--canvas--2ryhb"};